import { render, staticRenderFns } from "./c-add-modify-video-dialog.vue?vue&type=template&id=7e84059a&"
import script from "./c-add-modify-video-dialog.vue?vue&type=script&lang=js&"
export * from "./c-add-modify-video-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports